// extracted by mini-css-extract-plugin
module.exports = {"root":"Collapse_root__z26Ae","scale":"Collapse_scale__vyZ2a","opacity":"Collapse_opacity__G_5nW","opened":"Collapse_opened__0L5_k"};